import React from 'react'
import { NestedValue, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { FormGroup } from '../../form/FormGroup'
import { WizardStep, WizardStepProps } from '../../form/WizardStep'
import { ControlledMultiHourSeriesPicker } from '../../form/ControlledMultiHourSeriesPicker'
import { projectVar } from '../../../apollo/reactive-vars'
import { FormValues as FullFormValues } from './form-values'

type InternalFormValues = {
  demandHourSeriesIds: NestedValue<FullFormValues['demandHourSeriesIds']>
}

type FormValues = Pick<FullFormValues, 'demandHourSeriesIds'>

type Props = WizardStepProps<FullFormValues> & {
  onSubmit: (values: FormValues) => void
}

export function DemandsStep(props: Props): React.ReactElement {
  const { defaultValues, onSubmit } = props
  const { t } = useTranslation()

  const { control, handleSubmit, errors } = useForm<InternalFormValues>({
    defaultValues,
  })
  const project = useReactiveVar(projectVar)

  if (!project) {
    return <div />
  }

  return (
    <WizardStep
      {...props}
      title={t('createBuilding.pages.hourSeries.title')}
      onSubmit={handleSubmit(onSubmit)}
    >
      <FormGroup>
        <ControlledMultiHourSeriesPicker
          control={control}
          name="demandHourSeriesIds"
          error={errors.demandHourSeriesIds}
          collections={project.hourSeriesCollections}
        />
      </FormGroup>
    </WizardStep>
  )
}
